import { ResultProductsStyled } from './ResultProducts.style';
import ProductsList, { ProductListTypes } from 'components/Blocks/Product/List/ProductsList';
import { useCurrentLoadMoreQuery } from 'helpers/queryParams/useCurrentLoadMoreQuery';
import { useCurrentPageQuery } from 'helpers/queryParams/useCurrentPageQuery';
import { useTypedTranslationFunction } from 'hooks/typescript/UseTypedTranslationFunction';
import Trans from 'next-translate/Trans';
import { ListedProductType } from 'types/product';

type ResultProductsProps = {
    areProductsShowed: boolean;
    fetching: boolean;
    noProductsFound: boolean;
    products: ListedProductType[];
};

export const ResultProducts: FC<ResultProductsProps> = ({ areProductsShowed, noProductsFound, products, fetching }) => {
    const t = useTypedTranslationFunction();
    const currentPage = useCurrentPageQuery();
    const currentLoadMore = useCurrentLoadMoreQuery();

    return (
        <>
            {areProductsShowed && (
                <ProductsList
                    currentPage={currentPage}
                    gtmListName="search result"
                    isLoading={fetching}
                    products={products}
                    type={ProductListTypes.Normal}
                    isLoadMore={currentLoadMore > 0}
                />
            )}

            {!areProductsShowed && !noProductsFound && (
                <ResultProductsStyled>
                    <div>
                        <strong>{t('No results match the filter')}</strong>
                    </div>
                    <div>
                        <Trans i18nKey="ProductsNoResults" components={{ 0: <br /> }} />
                    </div>
                </ResultProductsStyled>
            )}

            {noProductsFound && (
                <ResultProductsStyled>
                    <div>
                        <strong>{t('No products matched your search')}</strong>
                    </div>
                </ResultProductsStyled>
            )}
        </>
    );
};
